<div style="overflow-y: hidden;">
    <div style="margin-bottom: 10px; display: flex; flex-wrap: wrap; align-items: start">
        <button class="form-item-button" style="margin: 0px 0px 0px 15px" mat-mini-fab
            (click)="flipperStateService.exportMarketFlipsToCSV(userSettingsService.getUserConsumedFlips(), 'consumed_flips')"
            [disabled]="!(userSettingsService.getUserConsumedFlips().length > 0)" color="primary"
            matTooltip="Export Consumed Flips Csv" aria-label="Export Consumed Flips Csv">
            <mat-icon>ios_share</mat-icon>
        </button>

        <button class="form-item-button" style="margin: 0px 0px 0px 15px" color="warn" mat-mini-fab
            (click)="removeAllConsumedFlips()" aria-label="Remove All Consumed Flips"
            matTooltip="Remove All Consumed Flips"
            [disabled]="!(userSettingsService.getUserConsumedFlips().length > 0)">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
    @if (getConsumedFlipsRunesDemand(); as runesDemand) {
    @if (runesDemand.length > 0) {
    <div style="display: flex; margin-top: 5px">
        <p>Total Runes Consumption:</p>
        @for (resource of runesDemand; track $index) {
        <div style="margin-left: 5px">{{ resource.item?.localizedName }}: {{ resource.count | number: '1.0-0' }}{{
            $index === runesDemand.length - 1 ? '' : ',' }}</div>
        }
    </div>
    }
    }
    <div class="table mat-elevation-z8 table consumed">
        <table mat-table [dataSource]="flipperStateService.consumedFlipsDataSource" #consumedFlipsSort="matSort"
            matSortStart="desc" matSort>
            <ng-container matColumnDef="itemUsCompleteName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Item Name</th>
                <td mat-cell *matCellDef="let flip">
                    <div style="display: flex; align-items: center">
                        <div style="padding-right: 5px">
                            <img [src]="imageService.getItemImageUrl(flip.item.uniqueName, undefined, 50)"
                                [alt]="flip.item.localizedName" />
                        </div>
                        <div style="display: flex; flex-direction: column; align-items: start; text-align: start">
                            @if (flip.isUpgrade) {
                            <div>
                                {{ flip.sellOrder.item.localizedName }}
                            </div>
                            <div>
                                <app-copy-text-button [text]="flip.sellOrder.item.localizedName"></app-copy-text-button>
                                <app-check-price-button
                                    [itemUniqueName]="flip.sellOrder.item.uniqueName"></app-check-price-button>
                            </div>
                            }
                            <div>
                                {{ flip.item.localizedName }}
                            </div>
                            <div>
                                <app-copy-text-button [text]="flip.item.localizedName"></app-copy-text-button>
                                <app-check-price-button
                                    [itemUniqueName]="flip.item.uniqueName"></app-check-price-button>
                            </div>
                        </div>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef>Totals</td>
            </ng-container>
            <ng-container matColumnDef="consumedAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Consumed<br />At</th>
                <th></th>
                <td mat-cell *matCellDef="let flip">
                    <p>{{ flip.consumedAt | date: 'mediumDate' : 'UTC' }}</p>
                    <p>{{ flip.consumedAt | date: 'shortTime' : 'UTC' }}</p>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="sellOrderUnitPriceSilver">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Buy At</th>
                <td mat-cell *matCellDef="let flip">
                    <div class="stack-text">{{ flip.sellOrder.location.displayName }} - {{
                        flip.sellOrder.qualityLevel.name }}
                    </div>
                    <div class="stack-text">
                        {{ flip.sellOrder.unitPriceSilver | number: '1.0-0' }}
                        @if (flipperStateService.countOrderIsUsedInMultipleFlips(flip.sellOrder.id); as count) {
                        <span style="cursor: help" [matTooltip]="
                        'Caution. This order is used in ' + count + ' possible flips. Don\'t assume you can use it multiple times. Consume the flip first.'
                      ">⚠️</span>
                        }
                    </div>
                    <div class="stack-text">{{ flip.sellOrder.getAgeInMinutes(flipperStateService.currentDateTime()) |
                        number: '1.0-0' }}
                        mins ago
                    </div>
                    <div class="stack-text">Sell Order Quantity: {{ flip.sellOrder.amount | number: '1.0-0' }}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getConsumedFlipsTotalBuy() | smallNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="buyOrderUnitPriceSilver">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Sell At</th>
                <td mat-cell *matCellDef="let flip">
                    <div class="stack-text">{{ flip.buyOrder.location.displayName }} - {{
                        flip.buyOrder.qualityLevel.name }}
                    </div>
                    <div class="stack-text">
                        {{ flip.buyOrder.unitPriceSilver | number: '1.0-0' }}
                        @if (flipperStateService.countOrderIsUsedInMultipleFlips(flip.buyOrder.id); as count) {
                        <span style="cursor: help" [matTooltip]="
                        'Caution. This order is used in ' + count + ' possible flips. Don\'t assume you can use it multiple times. Consume the flip first.'
                      ">⚠️</span>
                        }
                    </div>
                    <div class="stack-text">{{ flip.buyOrder.getAgeInMinutes(flipperStateService.currentDateTime()) |
                        number: '1.0-0' }} mins
                        ago
                    </div>
                    <div class="stack-text">Buy Order Quantity: {{ flip.buyOrder.amount | number: '1.0-0' }}</div>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getConsumedFlipsTotalSell() | smallNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="upgrade">
                <th mat-header-cell *matHeaderCellDef class="min-width-160">Upgrade Items</th>
                <td mat-cell *matCellDef="let flip">
                    @if (flip.isUpgrade) {
                    <div style="display: flex; flex-direction: column; align-items: start">
                        @for (resource of flip.upgradeResources; track $index) {
                        <div style="display: flex; flex-direction: column; align-items: start; text-align: start">
                            <div class="stack-text">
                                {{ resource.count | number: '1.0-0' }} x {{ resource.item.localizedName }}: ${{
                                resource.price |
                                number: '1.0-0' }}
                            </div>
                            <div style="display: flex; align-items: center">
                                <app-copy-text-button [text]="resource.item.localizedName"></app-copy-text-button>
                                <app-check-price-button
                                    [itemUniqueName]="resource.item.uniqueName"></app-check-price-button>
                                @if (resource.price === 0 || resource.price === null || resource.price === undefined) {
                                <span style="cursor: help" matTooltip="Missing resource price">⛔</span>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    } @else {
                    <div class="stack-text">-</div>
                    }
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <ng-container matColumnDef="upgradeCost">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Upgrade<br />Cost</th>
                <td mat-cell *matCellDef="let flip">
                    <p>{{ flip.upgradeCost | number: '1.0-0' }}</p>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getConsumedFlipsTotalUpgradeCost() | smallNumber }}</td>
            </ng-container>
            <ng-container matColumnDef="profitPremium">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Profit<br />(Premium)</th>
                <td mat-cell *matCellDef="let flip">
                    <p>{{ flip.profitPremium | number: '1.0-0' }}</p>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getConsumedFlipsTotalProfitPremium() | smallNumber }}</td>
                <td></td>
            </ng-container>
            <ng-container matColumnDef="profitPercentagePremium">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Profit %<br />(Premium)</th>
                <td mat-cell *matCellDef="let flip">
                    <p>{{ flip.profitPercentagePremium | percent: '1.2-2' }}</p>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getConsumedFlipsTotalProfitPercentagePremium() | percent:
                    '1.2-2'
                    }}</td>
            </ng-container>
            <ng-container matColumnDef="profitNonPremium">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Profit<br />(Non-Premium)
                </th>
                <td mat-cell *matCellDef="let flip">
                    <p>{{ flip.profitNonPremium | number: '1.0-0' }}</p>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getConsumedFlipsTotalProfitNonPremium() | smallNumber }}</td>
                <td></td>
            </ng-container>
            <ng-container matColumnDef="profitPercentageNonPremium">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Profit %<br />(Non-Premium)
                </th>
                <td mat-cell *matCellDef="let flip">
                    <p>{{ flip.profitPercentageNonPremium | percent: '1.2-2' }}</p>
                </td>
                <td mat-footer-cell *matFooterCellDef>{{ getConsumedFlipsTotalProfitPercentageNonPremium() | percent:
                    '1.2-2' }}</td>
            </ng-container>
            <ng-container matColumnDef="consumeFlip">
                <th mat-header-cell *matHeaderCellDef>Remove<br />Flip</th>
                <td mat-cell *matCellDef="let flip" class="min-width-80">
                    <button color="warn" mat-mini-fab (click)="removeConsumedFlip(flip)"
                        class="mat-mini-fab small-mini-fab" aria-label="Remove Consumed Flip">
                        <mat-icon>close</mat-icon>
                    </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="consumedFlipsDisplayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: consumedFlipsDisplayedColumns"></tr>
            <tr mat-footer-row *matFooterRowDef="consumedFlipsDisplayedColumns"
                style="background-color: rgba(0, 0, 0, 0.05);"></tr>
        </table>
    </div>
    <div>
        <mat-paginator #consumedFlipsPaginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons
            aria-label="Select page of flips"> </mat-paginator>
    </div>
</div>